/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EsslSearchRequestBody } from '|api/commons';
import { PageProcessInstanceDto } from '../../models/page-process-instance-dto';

export interface AutomatedProcessSearchProcessInstances$Params {
  workflowTriggerEventProcessId: number;
  
    /**
     * Search API request body.
     */
    body?: EsslSearchRequestBody|null|undefined
}

export function automatedProcessSearchProcessInstances(http: HttpClient, rootUrl: string, params: AutomatedProcessSearchProcessInstances$Params, context?: HttpContext): Observable<StrictHttpResponse<PageProcessInstanceDto>> {
  const rb = new RequestBuilder(rootUrl, automatedProcessSearchProcessInstances.PATH, 'post');
  if (params) {
    rb.path('workflowTriggerEventProcessId', params.workflowTriggerEventProcessId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageProcessInstanceDto>;
    })
  );
}

automatedProcessSearchProcessInstances.PATH = '/automated-process/process-instance/{workflowTriggerEventProcessId}/search-api';